<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery" :model="queryParam" >
          <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.seatgroup.sgroupname']">
             <a-input v-model="queryParam.sgroupname" maxLength="50"  :placeholder="this.language['cs.seatgroup.sgroupname']"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24" v-show="isShow">
            <a-form-item :label="this.language['cs.activity.activityname']">
              <a-Select @change="handChangeActivity"  v-model="queryParam.sysactivityid" :options="selectActivityList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.activity.activityname']"  >
              </a-Select></a-form-item>
          </a-col>
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.persongroup.pgroupname']">
              <a-Select  mode="multiple" v-model="queryParam.syspgidlist"  :options="selectPgList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.persongroup.pgroupname']"  >
              </a-Select></a-form-item>
          </a-col> -->
          
          
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
      
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus" >新增</a-button>
        <!-- 高级查询区域 -->
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel" ><a-icon type="delete"/>删除</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
  
      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
  
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="syssgid"
          class="j-table-force-nowrap"
          :scroll="{x:1800}"
          :dataSource="dataSource"
          :pagination="ipagination"
          :columns="columns"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)" >{{language['common.edit']}}</a>
            
            <!-- <a-divider type="vertical" />
            <a @click="handleSetSeat(record)" >設置分區</a> -->
            
            <a-divider type="vertical" />
  
            <a-dropdown>
              <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)">{{language['common.look']}}</a>
                </a-menu-item>
                <a-menu-item >
                  <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.syssgid)">
                    <a>{{language['common.delete']}}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
      </div>
 
      <seat-group-modal ref="modalForm" @ok="modalFormOk"></seat-group-modal>
      <j-modal ref="SetGroupSeatForm"
    :title="titleSetSeat"
    width="100%"
    :visible="seatvisible"
    switchFullscreen
    @ok="handleSeatOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleSeatCancel"
    cancelText="关闭">
    <template >
      <set-group-seat-form ></set-group-seat-form>
 
    </template>
      </j-modal>
    </a-card>
  </template>
  
  <script>
    import { httpAction, getAction } from '@/api/manageChooseSeat'
    import '@/assets/less/TableExpand.less'
    import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'
    import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
    import { getDictItemsFromCache  } from '@/api/api'
    import SeatGroupModal from './modules/SeatGroupModal'
    import SetGroupSeatForm from './modules/SetGroupSeatForm'
   
    export default {
      name: "SeatGroupList",
      mixins:[JeecgListMixin],
      inject:['dataActivity'],
      components: {
        SeatGroupModal,
        SetGroupSeatForm
      },
      data () {
        return {
          description: '座位分組信息',
          // 表头
         
          url: {
            list: "/SeatGroup/list",
            delete: "/SeatGroup/delete",
            deleteBatch: "/SeatGroup/deleteBatch"
            
          },
          selectActivityList:[],
          selectPgList:[],
          seatvisible:false,
          disableMixinCreated: true,
          isShow:true,
          titleSetSeat:"設置分區",
          operation :{
           optiontype:"add",
           isshow: true,
           sysactivityid:"",
           sysvenueid:""
           },
        }
      },
      created() {
        this.loadSelectData();
        this.loadData(1);
      },
      mounted(){
      
      }, 
      provide(){
        return{
         operation:this.operation
        }
    },
      watch:{
        'queryParam.sysactivityid':function (val) {
                if (val) {
                  this.selectPgList=[];
                  let selectparams = { keytype: "pgroup", parentid:val};   
                    getAction('/SelectData/SelectDataList', selectparams).then((res) => {
                      if (res.success) {
                        this.selectPgList= res.result.records;
                      }
                  }); 
                } 
                else {
                  this.selectPgList=[];
                }
              }

      },
      computed: {
        language() {
          return this.$store.getters.language
        },
        columns() {
          if (this.language) {
            return  [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['cs.seatgroup.sgroupcode'],
              align:"center",
              width:150,
              dataIndex: 'sgroupcode'
            },
            {
              title:this.language['cs.seatgroup.sgroupname'],
              align:"left",
              width:150,
              dataIndex: 'sgroupname'
            },
            {
              title:this.language['cs.seatgroup.seatqty'],
              align:"right",
              width:150,
              dataIndex: 'seatqty'
            },
            {
              title:this.language['cs.seatgroup.sgroupcolor'],
              align:"left",
              width:150,
              dataIndex: 'sgroupcolor',
              customRender: (text, record) => {
            const color = record.sgroupcolor==""?"#ffffff":record.sgroupcolor;
            return {
              children: text,
              attrs: {
                style: `background-color: ${color}`,
              },
            };
          },
        },
            // {
            //   title:this.language['cs.persongroup.pgroupname'],
            //   align:"left",
            //   width:150,
            //   dataIndex: 'syspgoupnames'
            // }, 
            
            {
              title:this.language['cs.activity.activityname'],
              align:"left",
              width:150,
              dataIndex: 'activityname'
            },  
            {
              title:this.language['cs.venue.venuename'],
              align:"left",
              width:150,
              dataIndex: 'venuename'
            },  
            {
              title:this.language['common.creator'],
              align:"center",
              width:150,
              dataIndex: 'creator'
            },  
            {
              title:this.language['common.createTime'],
              align:"center",
              width:150,
              dataIndex: 'createdate'
            },  
            {
              title:this.language['common.modifier'],
              align:"center",
              width:150,
              dataIndex: 'modifier'
            },  
            {
              title:this.language['common.modifyTime'],
              align:"center",
              width:150,
              dataIndex: 'modifydate'
            },  
            {
              title: '操作',
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' },
            }
          ]
          }
        }
      },
      methods: {
        loadSelectData() { 
          this.selectActivityList=null; 
          let selectactivity= { keytype: "activity", parentid:""};  
           getAction('/SelectData/SelectDataList', selectactivity).then((res) => {
          if (res.success) {
            this.selectActivityList= res.result.records;
          }
         });  
         if(this.dataActivity!=null)
        {
        this.queryParam.sysactivityid=this.dataActivity.sysactivityid;
        this.queryParam.sysvenueid=this.dataActivity.sysvenueid;
        this.isShow=this.dataActivity.isShow;
        }
               
      },  
      handChangeActivity(val)
        {
          this.$set( this.queryParam, 'syspgidlist', '')
        },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "编辑";
      this.$refs.modalForm.disableSubmit = false;
      this.operation.optiontype="edit"; 
      this.operation.isshow=true;
      this.operation.sysactivityid=record.sysactivityid;
      this.operation.sysvenueid=record.sysvenueid
    },
    handleAdd: function () {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = "新增";
      this.$refs.modalForm.disableSubmit = false;
      this.operation.optiontype="add";
      this.operation.isshow=false;

    },
    handleSetSeat:function(record){
      this.titleSetSeat=record.venuename;
      this.operation.sysactivityid=record.sysactivityid;
      this.operation.sysvenueid=record.sysvenueid;
      this.operation.syssgid=record.syssgid;
      this.operation.sgroupcolor=record.sgroupcolor;
      this.seatvisible=true;
    },
    handleSeatOk()
    {
      this.seatvisible=false;
    },
    handleSeatCancel()
    {
      this.seatvisible=false;
    },
        searchQuery() {
        
        this.loadData(1);
        },
        searchReset() {
      this.queryParam = {}
      if(this.dataActivity!=null)
        {
        this.queryParam.sysactivityid=this.dataActivity.sysactivityid;
        this.queryParam.sysvenueid=this.dataActivity.sysvenueid;
        }
      this.loadData(1);
    },
      }
    }
  </script>
  <style scoped>
    @import '~@assets/less/common.less';
   
  </style>
   <style lang="less">
   .full-modal {
     .ant-modal {
       max-width: 100%;
       top: 0;
       padding-bottom: 0;
       margin: 0;
     }
     .ant-modal-content {
       display: flex;
       flex-direction: column;
       height: calc(100vh);
     }
     .ant-modal-body {
       flex: 1;
     }
   }
  </style>